import React, { useContext, useState } from "react";
import styles from "./DeleteUser.module.scss";
import { MdOutlineCancel } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BsFillTrashFill } from "react-icons/bs";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import NavContext from "../../../context/NavContext";
import Axios from "../../../_services/caller.service";
import Modal from "../../UiComponents/modals/Modal";

const DeleteUser = ({
  name,
  lastName,
  userId,
  ownerId: ownerIdProp,
  setMaj,
  onDeleteSuccess,
}) => {
  const { t } = useTranslation();
  const { ownerId: ownerIdContext } = useContext(NavContext);
  const finalOwnerId = ownerIdProp !== undefined ? ownerIdProp : ownerIdContext;

  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const deleteUser = async () => {
    setLoading(true);
    console.log(`
🔍 === SUPPRESSION UTILISATEUR ===
ownerId: ${finalOwnerId}
userId: ${userId}
name: ${name} ${lastName}
setMaj type: ${typeof setMaj}
    `);

    try {
      const url = `/deleteuserlink/${finalOwnerId}?userId=${userId}`;
      console.log(`📡 Requête DELETE: ${url}`);

      const response = await Axios.delete(url);

      console.log("✅ Réponse serveur:", response.data);

      if (response.data && !response.data.error) {
        toast.success(`✅ ${t("team.access_deleted", { name: `${name} ${lastName}` })}`);

        console.log("🔄 Déclenchement du rafraîchissement");
        if (typeof setMaj === "function") {
          setMaj((prev) => !prev);
        }

        setShowConfirm(false);

        if (onDeleteSuccess) {
          console.log("📞 Callback onDeleteSuccess appelé");
          onDeleteSuccess();
        }
      } else {
        const errorMsg =
          response.data?.message || t("team.delete_error");
        console.error("❌ Erreur serveur:", errorMsg);
        toast.error(`❌ ${errorMsg}`);
      }
    } catch (error) {
      console.error("❌ Erreur:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        t("team.delete_error");
      toast.error(`❌ ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ── Trash icon ── */}
      <div
        className={`${styles.deleteUser} has-tooltip`}
        onClick={() => setShowConfirm(true)}
        aria-label={t("team.delete_access")}
      >
        <BsFillTrashFill />
     
      </div>

      {/* ── Confirmation modal ── */}
      <Modal
        isShowing={showConfirm}
        hide={() => setShowConfirm(false)}
        title={t("team.delete_access")}
      >
        <div className={styles.modalContent}>
          <p className={styles.confirmText}>
            {t("team.confirm_delete_access")}{" "}
            <strong>{name} {lastName}</strong> ?
          </p>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              className={styles.btnCancel}
              onClick={() => setShowConfirm(false)}
              disabled={loading}
            >
              <MdOutlineCancel /> {t("common.cancel")}
            </button>
            <button
              type="button"
              className={styles.btnDanger}
              onClick={deleteUser}
              disabled={loading}
            >
              <AiOutlineCheckCircle /> {loading ? t("team.deleting") : t("common.confirm")}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteUser;
